import React from 'react';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './Page.module.css';

const MachiningSkill = () => {
    return (
        <div className='Page MachiningSkill'>
            <Banner title={`Traditional Machining`} custom={true} />
            <section className={styles.section}>

            </section>
            <Footer></Footer>
        </div>
    );
};

export default MachiningSkill;